import loadable from '@loadable/component';

export const UserDashboardSavedItemsPageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "userDashboard/pages/UserDashboardSavedItemsPage" */
      './UserDashboardSavedItemsPage.dynamic'
    ),
);
